<script>
  import { OTHER } from '../colors.js';
  import { intcomma } from 'journalize';
  import parties from '../utils/parties';

  /** @type {string} */
  export let name;
  /** @type {string} */
  export let color;
  /** @type {string} */
  export let party;
  /** @type {number} */
  export let votes;
  /** @type {string} */
  export let votePercent;
  /** @type {boolean} */
  export let includeParty;
  /** @type {boolean} */
  export let isWinner = '';
  /** @type {string} */
  export let race = '';
  // $: console.log(includeParty)
</script>

{#if race !== 'congress'}
  <tr class="candidate contest__candidate-row">
    <th scope="row" class="candidate__cell candidate__cell-name text-regular">
      {#if includeParty}
        <span
          class="circle-pill"
          style="background-color: {color}; color: {color};"
        />
      {/if}
      <span class="text-bold">{name}</span> <span>({parties[party].abbr})</span>
    </th>
    {#if includeParty}
      <td class="candidate__cell candidate__cell-votes text-left">
        {party ? party.toUpperCase() : ''}
      </td>
    {/if}
    <td class="candidate__cell candidate__cell-pct text-right">{votePercent}</td
      >
    <td class="candidate__cell candidate__cell-votes text-right">
      {intcomma(votes)}
    </td>
  </tr>
{:else}
  <tr class="candidate contest__candidate-row">
    <th scope="row" class="candidate__cell candidate__cell-name text-regular">
      <span class="text-bold"
        >{name}{#if isWinner}
          <span class="ml-n3">✓</span>
        {/if}</span
      >
    </th>
    <td class="candidate__cell candidate__cell text-left">
      {party ? party.toUpperCase() : ''}
    </td>
    <td class="candidate__cell candidate__cell-pct text-right">{votePercent}</td
      >
    <td class="candidate__cell candidate__cell-votes text-right">
      {intcomma(votes)}
    </td>
  </tr>
{/if}
